/**
 * ADS modal fleet — stack layer contract (Phase D).
 *
 * Use: AdsDialog / AdsConfirmDialog from `components/ads`.
 * Layers: tokens/layout.css · styles/components/ads/modal-stack.css · dialog.css
 *
 * Ladder (low → high):
 *   base backdrop 1000 → fullscreen 1100 → nested 1150 → nested-2 1180
 *   → popover 1190 → tooltip 1220 → confirm 10000 → toast 10200
 *
 * Focus trap / a11y (AdsDialog):
 *   - role="dialog" + aria-modal + aria-labelledby
 *   - focus dialog panel on open; Escape calls onClose
 *   - scroll lock via acquireModalScrollLock while present
 *   - body-portal so z-ladder is independent of page overflow
 *   - closeOnBackdrop defaults true; confirm layer for blocking dialogs
 *
 * ERP rule: new shared form/confirm modals MUST use AdsDialog + MODAL_LAYER.
 * Specialization (POS/restaurant): may use own shells; z via --pos-z-* → ADS ladder.
 */
export const MODAL_LAYER = Object.freeze({
  /** Default document modal (AdsDialog without nested/fullscreen/layer). */
  BASE: null,
  /** Above parent modal — e.g. quick-add product over purchase form. */
  NESTED: true,
  /** Third tier — comment / picker over nested parent. */
  NESTED_2: 2,
  /** Destructive or blocking confirm — AdsConfirmDialog, unsaved guards. */
  CONFIRM: 'confirm',
});

/** Resolve AdsDialog `nested` prop from fleet constant. */
export function resolveModalNested(layer) {
  if (layer === MODAL_LAYER.NESTED_2) return 2;
  if (layer === MODAL_LAYER.NESTED) return true;
  return false;
}
